import { ROUTES, withLocale } from "@/config/routes";
import { accountType } from "@/shared/api/browser/accountType";
import { Wallet } from "@cronika/assets/icons";
import { useTranslation } from "@cronika/locales";
import { Button, Modal, ModalContent } from "@cronika/ui";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type InsufficientBalanceModalProps = {
  isOpen: boolean;
  onClose: () => void;
  balance: number;
  betAmount: number;
};

export const InsufficientBalanceModal: FC<InsufficientBalanceModalProps> = ({
  isOpen,
  onClose,
  balance,
  betAmount,
}) => {
  const { t } = useTranslation("trading");
  const navigate = useNavigate();

  const handleDeposit = () => {
    onClose();
    navigate(withLocale(ROUTES.WALLET));
  };

  const handleContinueDemo = () => {
    accountType.set("demo");
    onClose();
  };

  return (
    <Modal open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <ModalContent
        variant="gradient"
        backdrop="opaque"
        className="top-1/2! -translate-y-1/2! left-1/2! -translate-x-1/2! right-auto! md:top-20! md:right-4! md:left-auto! md:translate-x-0! md:translate-y-0! max-w-[320px]! w-[calc(100%-2rem)]! bg-[#0A0A0B] border border-white/10 shadow-2xl data-[state=open]:slide-in-from-top-2 data-[state=closed]:slide-out-to-top-2 duration-300"
      >
        <div className="p-5">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-warning font-bold text-base leading-tight">{t("insufficient-balance-modal.title")}</h3>
          </div>

          <div className="grid grid-cols-2 gap-3 mb-4">
            <div>
              <p className="text-[#E5FFFF8F] text-xs mb-1">{t("insufficient-balance-modal.your-balance")}</p>
              <p className="text-white font-semibold text-lg">$ {balance.toFixed(0)}</p>
            </div>
            <div>
              <p className="text-[#E5FFFF8F] text-xs mb-1">{t("insufficient-balance-modal.bet-amount")}</p>
              <p className="text-white font-semibold text-lg">$ {betAmount.toFixed(0)}</p>
            </div>
          </div>

          <p className="text-[#E5FFFF8F] text-xs leading-relaxed mb-4">{t("insufficient-balance-modal.description")}</p>

          <Button
            variant="glow"
            size="lg"
            fullWidth
            className="font-semibold mb-3"
            startContent={<Wallet className="w-4 h-4 mr-1" />}
            onClick={handleDeposit}
          >
            {t("insufficient-balance-modal.deposit-btn")}
          </Button>

          <button
            className="w-full text-center text-sm text-white/70 underline hover:text-white transition-colors"
            onClick={handleContinueDemo}
          >
            {t("insufficient-balance-modal.demo-link")}
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
};
